module.exports = "<div class=\"radio-button\">\n  <input type=\"radio\"\n    name=\"{{myId}}\"\n    id=\"{{myId}}\"\n    class=\"with-gap radio-orange\"\n    ng-model=\"ngModel\"\n    ng-value=\"myValue\"\n    ng-click=\"myClick()\"\n    tabindex=\"{{myTabindex}}\" />\n  <label for=\"{{myId}}\"\n    ng-bind-html=\"myLabel\">\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/buttons/myRadioButton.html
// module id = 1210
// module chunks = 0